module.exports = __webpack_public_path__ + "static/media/sport24.4d785f32.png";